// extracted by mini-css-extract-plugin
export var arrow = "_0mh9Q";
export var main = "IHMSZ";